module.exports = __webpack_public_path__ + "img/c7.1cb0b05f.jpg";